export enum IconTypes {
  PASSWORD = "password",
  USER = "user",
}

export enum BasicInputMode {
  LIGHT = "light",
  DEFAULT = "default",
  TYPOGRAPHY = "typography",
}

export enum BasicInputIconPlacement {
  END = "end",
  START = "start",
}
